// file-save - no upload
import { useState, useRef } from "react";

import { Row, Col } from 'antd';

export default function FileSaver (props) {

  const [stat, setStatus] = useState('Select File...');
  const [done, setDone] = useState(0); 
  const [link, setLink] = useState(props.avtr || 'https://firebasestorage.googleapis.com/v0/b/finnovate99.appspot.com/o/webb%2Ffilesave.png?alt=media&token=9acb1627-380a-48a6-b9b6-e174806a79ef' );
  const [base, setBase] = useState();
  const [file, setFile] = useState();
  
  let inputFile = useRef(null);
  
  const SetFileData = async(data) => {
    // console.log ('file: ',data);
    
    const reader = new FileReader();
    reader.onloadend = () => {
      // use a regex to remove data url part
      const base64String = reader.result

      // log to console
      // console.log(base64String);
      setBase(base64String);
      props.base(base64String);
    };
    reader.readAsDataURL(data);

  }

  const handleFile = e => {
    const { files } = e.target;
    setStatus('New File...')

    if (files && files.length) {
      setFile(files[0]);
      setLink(URL.createObjectURL(files[0]));
      SetFileData(files[0]);
      // props.file(files[0]);
      setDone(100);
    }
  };


  const onButtonClick = () => {
    inputFile.current.click();
  };


  const handleFileRemove = async () => {
    setFile(null);
    inputFile.current.value=null
    setLink(null);
    SetFileData(null);
    setDone(0);
    setLink('https://firebasestorage.googleapis.com/v0/b/finnovate99.appspot.com/o/webb%2Ffilesave.png?alt=media&token=9acb1627-380a-48a6-b9b6-e174806a79ef')
    setStatus('Select File...')
  }

  return (
  <>

    <div className="border rounded-wd">

      <div className="p-2 border-bottom">
        
        <Row justify="start" >
          <Col span={21}>
            <p className="text-bold m-0">{file? file.name : '******'}</p>
            <p className="m-0 text-small text-color-tone">{file? `${Math.trunc(file.size/1024)}kb` : '******'}</p>
            <p className="m-0 text-small text-color-tone d-none">{'Status: '}{stat}</p>
          </Col>

          <Col span={3}  className="text-end text-color-tone">
            <Row align="middle" justify="center" 
              className={`text-center back-color-lite hilite ${done==0 ? 'text-color-main': 'd-none'}`}
              style={{width:'2.7rem', height:'2.7rem', borderRadius:'50%', cursor:'pointer'}}
              onClick={() => onButtonClick()}
              ><i className={`bx bx-plus`} style={{fontSize:'1.25rem'}}></i>
            </Row>

            <Row align="middle" justify="center"
              className={`text-center back-color-lite hilite ${done===100 ? '': 'd-none'}`}
              style={{width:'2.7rem', height:'2.7rem', borderRadius:'50%', cursor:'pointer'}}
              onClick={() => handleFileRemove()}
              ><i className={`bx bx-x`} style={{fontSize:'1.25rem'}}></i>
            </Row>

          </Col>
        </Row>
      </div>

      {/* view */}
      <div className="media-square">
        <img src={link} alt="media" className="rounded-wd"
          style={{borderTopLeftRadius:0, borderTopRightRadius:0}}
        />
      </div>
      
    </div>

    <div className="mb-3">
      <input 
        type="file" id="file"
        accept="image/*" 
        className="border-none"
        ref={inputFile}
        onChange= {handleFile} 
        style={{display: "none"}}
      ></input>
    </div>

  </>
  )
}